import React from 'react';
import Html from 'react-pdf-html';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
// import { valueIsNull } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 11,
        marginTop: 5,
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    container:{
        paddingTop:'3px',
        paddingLeft:'3px',
        paddingRight:'3px',
        flexDirection: 'row',
        fontWeight:'normal',
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    text:{
        fontSize: 9,
        textAlign:'justify'
        // whiteSpace: 'pre-line'
    },
    h2:{
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        // whiteSpace: 'pre-line'
    }
  });

  const formatText = (text) => {
    text = text.replaceAll('strong', 'h2');
    text = text.replaceAll('/h2>', '/h2><br/>');
    text = text.replaceAll('<h2>', '<h2 style={{fontSize:"10px"}}>');
    return text.replaceAll('</p>', '</p><br/><br/>');
  }

  const ProposalContract = ({title, value}) => {
      return (typeof value !== 'undefined' && value !== null && value !== '') ? 
        <>
            <Text style={styles.reportTitle}>{title}</Text>
            <View style={styles.container}>
                <Text><Html style={styles.text}>{formatText(value)}</Html></Text>
            </View>
        </> : '' // <html><body></body></html> 
  }
  
  export default ProposalContract